import ContactFooter from "../components/ContactFooter";
import Hero from "../components/Hero";
import React from "react";
import { useTranslation } from "react-i18next";

const ErrorPaymentPage = () => {
  const { t } = useTranslation();
  const heroData = {
    image: "hero-home.png",
    title: t("error_payment_page.title"),
    subtitle: t("error_payment_page.subtitle"),
    link: "/",
    linkName: t("error_payment_page.linkName"),
  };

  return (
    <div className="home-holder-content">
      <div className="container">
        <Hero data={heroData} />
        <ContactFooter />
      </div>
    </div>
  );
};

export default ErrorPaymentPage;
